import _ from 'underscore';

import { ProjectMapper } from '~src/projects/models/mappers/ProjectMapper';

import { ILocationInfo } from '../../../personalSpace/model/ILocationInfo';
import { IMetricUsageInfo } from '../../../spacesPlatform/models/IUsageInfo';
import { ContentMapper } from '../../../spacesPlatform/models/mappers/ContentMapper';
import { MapperHelper } from '../../../spacesPlatform/models/mappers/MapperHelper';
import { INamedItemInfo } from '../../../spacesPlatform/models/resourceInfoParts';
import { IUserInfo } from '../../../userManagement/users/models/IUserInfo';
import { UserMapper } from '../../../userManagement/users/models/mappers/UserMapper';
import { IConnectedView, IMetric, IMetricDetail } from '../../serverApi/types/IMetric';
import { IConnectedViewInfo, IMetricInfo } from '../IMetricInfo';

export module MetricMapper {
  const M = MapperHelper;

  export function map(
    serverApiMetrics: IMetric[],
    users: _.Dictionary<IUserInfo>,
    projects: _.Dictionary<INamedItemInfo>,
    locations: ILocationInfo[] = [],
    connectedViews: _.Dictionary<IConnectedViewInfo>,
    usageInfoMaxValues?: IMetricUsageInfo,
    favoriteMetrics: _.Dictionary<any> = {}
  ): IMetricInfo[] {
    const metricsToProject = ContentMapper.getContentToProjectMap(ContentMapper.ContentTypeToTargetMap.metric, projects);
    const metricsToLocation = ContentMapper.getContentToLocationMap(ContentMapper.ContentTypeToTargetMap.metric, locations);
    return serverApiMetrics.map((m: IMetric) => {
      return mapOne(m, users[m.ownerId], metricsToProject[m.id],
        connectedViews[m.connectedViewPath], usageInfoMaxValues, !!favoriteMetrics[m.id],metricsToLocation[m.id]);
    });
  }

  export function mapOne(
    metric: IMetric,
    owner?: IUserInfo,
    project?: INamedItemInfo,
    connectedView?: IConnectedViewInfo,
    usageInfoMaxValues?: IMetricUsageInfo,
    favorite?: boolean,
    location?: ILocationInfo
  ): IMetricInfo {
    return {
      createdAt:                    M.toDate(metric.createdAt),
      updatedAt:                    M.toDate(metric.updatedAt),
      suspended:                    metric.suspended,
      description:                  metric.description,
      id:                           metric.id,
      luid:                         metric.luid,
      name:                         metric.name,
      owner:                        UserMapper.mapOne(owner),
      favorite:                     favorite,
      contentType:                  'metric',
      tags:                         M.sortTags(metric.tags),
      connectedView:                connectedView,
      project:                      project,
      location:                     location,
      usageInfo:                    metric.usageInfo || <IMetricUsageInfo>{},
      usageInfoMaxValues:           usageInfoMaxValues || <IMetricUsageInfo>{},
    };
  }

  export function mapDetail(
    metric: IMetricDetail
  ): IMetricInfo {
    return {
      createdAt:                    M.toDate(metric.createdAt),
      updatedAt:                    M.toDate(metric.updatedAt),
      suspended:                    metric.suspended,
      description:                  metric.description,
      id:                           metric.id,
      luid:                         metric.luid,
      name:                         metric.name,
      owner:                        UserMapper.mapOne(metric.owner),
      favorite:                     metric.favorite,
      contentType:                  'metric',
      tags:                         M.sortTags(metric.tags),
      connectedView:                (metric.connectedViewViewModel && mapOneConnectedView(metric.connectedViewViewModel)),
      project:                      ProjectMapper.mapName(metric.project)
    };
  }

  export function mapConnectedViews(
    serverApiConnectedViews: IConnectedView[]
  ): IConnectedViewInfo[] {
    return serverApiConnectedViews.map((cv: IConnectedView) => mapOneConnectedView(cv));
  }

  export function mapOneConnectedView(
    connectedView: IConnectedView
  ): IConnectedViewInfo {
    return {
      id:                           connectedView.id,
      viewId:                       connectedView.viewId,
      name:                         connectedView.name,
      isViewModified:               connectedView.isViewModified,
      path:                         connectedView.path,
      thumbnailUrl:                 connectedView.thumbnailUrl,
      type:                         connectedView.type
    };
  }

  export function mapFromCRASS(metric: any): IMetricInfo{
    return {
      createdAt:                    M.toDate(metric.createdTime) || M.toDateFromTimeOffsetObject(metric.createdTime),
      updatedAt:                    M.toDate(metric.modifiedTime) || M.toDateFromTimeOffsetObject(metric.modifiedTime),
      suspended:                    metric.suspendState !== 'NotSuspended',
      description:                  metric.description,
      id:                           metric.id + '',
      luid:                         metric.luid,
      name:                         metric.title,
      favorite:                     false,
      contentType:                  'metric',
      tags:                         M.sortTags(metric.tags),
      connectedView:                null,
      project: {
        id:                         metric.projectId ?? metric.parentProjectId,
        name:                       metric.containerName
      },
      owner:                        UserMapper.mapOneOwnerFromCRASS(metric),
      usageInfo:                    <IMetricUsageInfo>{
        ...MapperHelper.mapCRASSUsageInfo(metric)
      },
      usageInfoMaxValues:           <IMetricUsageInfo>{}
    };
  }
}
